const config = {
  environment: window.config.environment,
  appUrl: window.config.appUrl,
  backendUrl: window.config.backendUrl,
  mockOtp: window.config.mockOtp,
  hideAndroidDialogs: window.config.hideAndroidDialogs,
  clevertapAccountId: window.config.clevertapAccountId,
  paymentService: window.config.paymentService,
  farmerAppBaseUrl: window.config.farmerAppBaseUrl,
  outputUiBaseUrl: window.config.outputUiBaseUrl,
  disablePayNow: window.config.disablePayNow,
  farmerAppBackendUrl: window.config.farmerAppBackendUrl,
  farmerWebAppBaseUrl: window.config.farmerWebAppBaseUrl,
  crmService: window.config.crmService,
  cartService: window.config.cartService,
  offerService: window.config.offerService,
  ticketService: window.config.ticketService,
  dialerService: window.config.dialerService,
  referralService: window.config.referralService,
  crmStatisticService: window.config.crmStatisticService,
  orderManagementService: window.config.orderManagementService,
  institutionalSalesService: window.config.institutionalSalesService,
  feedService: window.config.feedService,
  userService: window.config.userService,
  weatherService: window.config.weatherService,
  contentService: window.config.contentService,
  catalogService: window.config.catalogService,
  versionService: window.config.versionService,
  communicationService: window.config.communicationService,
  shopAggregatorService: window.config.shopAggregatorService,
  onlineEcommerceService: window.config.onlineEcommerceService,
  invoicePrintService: window.config.invoicePrintService,
  productDetectionEngine: window.config.productDetectionEngine,
  firebaseConfig: window.config.firebaseConfig,
  reactAppVersion: "16.2.6",
};

export default config;
